import { TeamsCardSecWrapper } from "../../styles/StyledComponents/MeetOurTeamCompWrapper";
import { ITeamsCardSecProps } from "../../ui/interface";

const TeamsCardSec = ({ cardImage, name, designation }: ITeamsCardSecProps) => {
  return (
    <TeamsCardSecWrapper>
      <figure>
        <img src={cardImage} alt={cardImage} />
      </figure>
      <div className="team_member_details_box">
        <h3>{name}</h3>
        <p>{designation}</p>
      </div>
    </TeamsCardSecWrapper>
  );
};

export default TeamsCardSec;
